import React, { FC } from "react";
import TickIcon from "../../../../../../images/common/tick-green.svg";
import CrossIcon from "../../../../../../images/common/cross-circle-red.svg";
import editIcon from "../../../../../../images/products/edit-blue.svg";
import AddIcon from "../../../../../../images/common/add-inside-circle-blue.svg";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { AddressModel, PaymentDetailModel } from "../../../shared/models";
import {
  DescriptionCell,
  ItemDetailLeftPanel,
  ItemDetailRightPanel,
  LabelCell,
  PropertyButtons,
} from "../../../shared/styles";
import { PaymentUtil } from "../../../shared/utils";
import { PaymentTransactionStatus } from "../../../shared/enums";
import { RenderPaymentMethod } from "../../../shared/components";
import { AccountSettingsStore } from "../../../shared/store";

type IProps = {
  data: PaymentDetailModel;
};

const DetailSection: FC<IProps> = ({ data: item }) => {
  const row = (
    label: string,
    rightColumn: string | React.ReactNode,
    className?: string
  ): React.ReactNode => {
    return (
      <FlexContainer className={`label-description-row ${className}`}>
        <LabelCell>
          <CustomLabel>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>{rightColumn}</DescriptionCell>
      </FlexContainer>
    );
  };

  const colors = PaymentUtil.getColorsByStatus(item.status);
  return (
    <>
      <FlexContainer>
        <ItemDetailLeftPanel>
          {row(
            "Status",
            <CustomButton
              bgColor={colors.bgColor}
              color={colors.color}
              minWidth={"90px"}
              fontWeight={"600"}
              padding="6px 10px"
            >
              {PaymentTransactionStatus[item.status]}
            </CustomButton>
          )}
          {row(
            "Created Date",
            <CustomLabel>
              <>
                {(item.createdDate &&
                  UtilityMethods.formatDateInStringWithTime(
                    item.createdDate
                  )) ||
                  "-"}
              </>
            </CustomLabel>
          )}
          {row(
            "Amount",
            item.grossAmount > 0 ? (
              <CustomLabel fontWeight={"600"}>
                ${AccountSettingsStore.formatAmount(item.grossAmount, true)}
                <span className="usd-grey">USD</span>
              </CustomLabel>
            ) : (
              "-"
            )
          )}
          {row(
            "Processing Fees",
            item.processingFee > 0 ? (
              <CustomLabel>
                ${AccountSettingsStore.formatAmount(item.processingFee, true)}
              </CustomLabel>
            ) : (
              "-"
            )
          )}
          {row(
            "Net Amount",
            item.netAmount > 0 ? (
              <CustomLabel fontWeight={"600"}>
                ${AccountSettingsStore.formatAmount(item.netAmount, true)}
              </CustomLabel>
            ) : (
              "-"
            )
          )}
          {row(
            "Description",
            <CustomLabel className="description-label">
              {item.description}
            </CustomLabel>
          )}
          {row("Payment ID", <CustomLabel>{item.id}</CustomLabel>)}
          {row(
            "Merchant Account",
            <CustomLabel>{item.merchantAccount?.name || ""}</CustomLabel>
          )}
          {item.donationPricingPageData && (
            <>
              <CustomLabel className="header-midnight-blue">
                Donation
                <img src={editIcon} />
              </CustomLabel>
              {/* {row(
                                'Beneficiary',
                                <>
                                    <FlexContainer spacing={20} padding="10px 0px" alignItems="center">
                                        <CustomLabel>$50</CustomLabel>
                                        <PropertyButtons width="auto">Football Team</PropertyButtons>
                                    </FlexContainer>
                                    <FlexContainer spacing={20} padding="10px 0px" alignItems="center">
                                        <CustomLabel>$50</CustomLabel>
                                        <PropertyButtons width="auto">Football Team</PropertyButtons>
                                    </FlexContainer>
                                </>,
                                'beneficiary-block',
                            )} */}
              {row(
                "Beneficiary",
                <>
                  {item.donationPricingPageData.selectedBeneficiaries.length > 0
                    ? item.donationPricingPageData.selectedBeneficiaries.map(
                        (beneficiary) => (
                          <FlexContainer
                            spacing={20}
                            padding="10px 0px 0px"
                            alignItems="center"
                            key={beneficiary.id}
                          >
                            <CustomLabel>
                              $
                              {AccountSettingsStore.formatAmount(
                                item.netAmount,
                                true
                              )}
                            </CustomLabel>
                            <PropertyButtons width="auto">
                              {beneficiary.name}
                            </PropertyButtons>
                          </FlexContainer>
                        )
                      )
                    : "-"}
                </>,
                "beneficiary-block"
              )}
              {row(
                "In Memoriam",
                item.donationPricingPageData.offerInMemoryOf ? (
                  <>
                    {item.donationPricingPageData.inMemoryOfName && (
                      <CustomLabel>
                        {item.donationPricingPageData.inMemoryOfName}
                      </CustomLabel>
                    )}
                    {item.donationPricingPageData.inMemoryOfComment && (
                      <CustomLabel margin="15px 0px 0px">
                        {item.donationPricingPageData.inMemoryOfComment}
                      </CustomLabel>
                    )}
                  </>
                ) : (
                  "-"
                )
              )}
              {row(
                "Recurrance",
                <CustomLabel>
                  {item.donationPricingPageData.oneTime
                    ? "One Time Donation"
                    : "Monthly donation"}
                </CustomLabel>
              )}
            </>
          )}
        </ItemDetailLeftPanel>
        <ItemDetailRightPanel>
          <div className="blue-label-container">
            {row(
              "Contact",
              <CustomLabel>
                {item.contact?.fullName || item.contact?.email}
              </CustomLabel>
            )}
            {row(
              "Payment Method",
              <FlexContainer fxLayout="column" spacing={10}>
                <RenderPaymentMethod paymentMethod={item.paymentMethod} />
              </FlexContainer>
            )}
            {row(
              "Subscription",
              <CustomLabel>{item.subscriptionId}</CustomLabel>
            )}
            {row("Invoice", <CustomLabel>{item.invoiceId}</CustomLabel>)}
            {row(
              "Refund",
              item.refundAmount > 0 ? (
                <CustomLabel>
                  ${AccountSettingsStore.formatAmount(item.refundAmount, true)}
                </CustomLabel>
              ) : (
                "-"
              )
            )}
            {/* {row("Payout", <CustomLabel>Payout ID</CustomLabel>)} */}
          </div>
          {/* {item.donationPricingPageData && (
            <>
              <CustomLabel className="header-midnight-blue">
                Referral
                <img src={editIcon} />
              </CustomLabel>
              <div className="blue-description-container">
                {row(
                  "Source",
                  <CustomLabel>Checkout “Holiday Special”</CustomLabel>
                )}{" "}
                {row(
                  "Referred By",
                  <CustomLabel className="clickable">
                    <img src={AddIcon} className="referral-add-icon" />
                    Add
                  </CustomLabel>
                )}{" "}
              </div>
              <CustomLabel className="header-midnight-blue">
                Payees
                <img src={editIcon} />
              </CustomLabel>
              <div className="blue-description-container">
                {row(
                  "Merchant",
                  <FlexContainer justifyContent="space-between">
                    <CustomLabel>School Operating</CustomLabel>
                    <CustomLabel className="standard-color">$40.00</CustomLabel>
                  </FlexContainer>
                )}
                {row(
                  "Vendor",
                  <FlexContainer justifyContent="space-between">
                    <CustomLabel>Supply House</CustomLabel>
                    <CustomLabel className="standard-color">$25.00</CustomLabel>
                  </FlexContainer>
                )}
                {row(
                  "Vendor",
                  <FlexContainer justifyContent="space-between">
                    <CustomLabel>The Shipping Pros</CustomLabel>
                    <CustomLabel className="standard-color">$22.12</CustomLabel>
                  </FlexContainer>
                )}{" "}
                {row(
                  "Affiliate",
                  <FlexContainer justifyContent="space-between">
                    <CustomLabel>John Sebastian</CustomLabel>
                    <CustomLabel className="standard-color">$9.68</CustomLabel>
                  </FlexContainer>
                )}{" "}
                {row(
                  "",
                  <FlexContainer justifyContent="space-between">
                    <CustomLabel></CustomLabel>
                    <CustomLabel
                      fontWeight="600"
                      className="standard-color border-top-grey"
                    >
                      $96.80
                    </CustomLabel>
                  </FlexContainer>
                )}{" "}
              </div>
            </>
          )} */}
        </ItemDetailRightPanel>
      </FlexContainer>
      {item.paymentMethod && (
        <>
          <CustomLabel className="header-midnight-blue">
            Payment Method
          </CustomLabel>
          <FlexContainer justifyContent="space-between">
            <div className="half-width">
              {row(
                "Account Holder",
                item.paymentMethod.card?.cardHolderName ||
                  item.paymentMethod.bank?.name
              )}
              {item.paymentMethod.card && (
                <>
                  {" "}
                  {row(
                    "Number",
                    <RenderPaymentMethod paymentMethod={item.paymentMethod} />
                  )}
                  {row(
                    "Expires",
                    `Expires on ${UtilityMethods.getMonth(item.paymentMethod.card?.expiryMonth)}, ${item.paymentMethod.card?.expiryYear}`
                  )}
                </>
              )}
              {item.paymentMethod.bank && (
                <>
                  {" "}
                  {row("Number", item.paymentMethod.bank?.maskedAccount || "")}
                </>
              )}
              {row("Issued By", "")}
              {row("Pay ID", item.paymentMethodId)}
            </div>
            <div className="half-width">
              {row(
                "Address",
                AddressModel.desrializeAddress(item.paymentMethod.card?.address)
              )}
              {row("Country", item.paymentMethod.card?.address?.country)}
              {row(
                "Street Check",
                <FlexContainer spacing={8} alignItems="center">
                  <img
                    src={
                      item.paymentMethod.card?.cvvCheck ? TickIcon : CrossIcon
                    }
                    className="yes-no-circle"
                  />
                  <CustomLabel>
                    {item.paymentMethod.card?.cvvCheck ? "Passed" : "Failed"}
                  </CustomLabel>
                </FlexContainer>
              )}
              {row(
                "Zip / Postal Check",
                <FlexContainer spacing={8} alignItems="center">
                  <img
                    src={
                      item.paymentMethod.card?.addressZipCheck
                        ? TickIcon
                        : CrossIcon
                    }
                    className="yes-no-circle"
                  />
                  <CustomLabel>
                    {item.paymentMethod.card?.addressZipCheck
                      ? "Passed"
                      : "Failed"}
                  </CustomLabel>
                </FlexContainer>
              )}
            </div>
          </FlexContainer>
        </>
      )}
    </>
  );
};
export default DetailSection;
